import { themeColors } from './themeColors';

const inputFormWidth = 530;

export const stylesConstants = {
  emailVerificationBoxWidth: 300,
  headerHeight: 100,
  sideMenuWidth: 240,
  inputFormWidth,
  inputOneLineHeight: 50,
  inputMultilineHeight: 150,
  tabInactiveHeight: 50,
  tabActiveHeight: 55,
  tabWidth: 150,
  defaultBorder: `1px solid ${themeColors.borders}`,
  switch: {
    container: {
      width: 42,
      height: 26,
    },
    thumb: {
      width: 24,
      height: 24,
    },
    border: `6px solid ${themeColors.secondary}`,
  },

  redbullIconWidth: 180,
  buttonHeight: 42,
  legendColorBox: {
    width: 30,
    height: 20,
  },
  checkboxGridRowHeight: 40,
  snack: {
    bottom: 16,
    position: 83, // 75 snack height + margin 8
  },
  loginFormMaxWidth: inputFormWidth / 2 + 32,
  // contentContainerMinWidth: 1156,
  // for Delete column
  contentContainerMinWidth: 1225,
};
